import $ from 'jquery';

// Header Toggle Sync (OMNI)
$('.header .search__input').on('keyup', function () {
  const searchText = $(this).val();
  const searchInputs = $('.header .search__input');
  searchInputs.each(function () {
    $(this).val(searchText);
  });
});

$('.search-bar-toggle:not(.is-active)').on('click', function() {
    $('.search-bar').find('.search__input').trigger('focus');
});

// show search term in search bar on the explore page
const $explorePage = $('.explore-page');

if ($explorePage.length != 0) {
  const $siteSearch = $('.explore-page__site-search');
  const term = $siteSearch.data('term');
  $siteSearch.find('.search__input').val(term);
}
